<template>
  <div class="modal-card" ref="element">

    <header class="modal-card-head">
      <p class="modal-card-title">{{playlistName}}</p>
    </header>

    <section class="modal-card-body" >
        <main class="grid">
          <div v-for="(im,id1) in libImages" :key="id1">
            <img :src="im.url" style="cursor:pointer" @click="isImageModalActive=true; selectedImage=im.url" alt="">
            <b-modal :active.sync="isImageModalActive" scroll="keep">
                <p class="image">
                    <img :src="selectedImage" >
                </p>
            </b-modal>
            <span class="caption">
            <table>
    <td>{{im.name}}</td>
    <td style="color:#3e8ed0">{{formatBytes(im.size, 2)}}</td>
            </table>
            </span>
          </div>

          <div v-for="(pd,id) in libPdfs" :key="'z' + id">
            <!--<img :src="im.url" @click="selectPdf(im.url, im.name, im.file)" :class="im.url === selectedUrl ? 'active' : ''" style="cursor:pointer" alt="">-->
            <div style="position:relative;">
            <iframe
    :src="pd.url"
    frameBorder="0"
    height="100%"
    width="100%"
    style="background: #FFFFFF"
></iframe>
            </div>
            <!--<span class="caption" @click="selectPdf(pd.url, pd.name, pd.file)" :style="pd.url === selectedUrl ? 'font-weight: bold' : ''" style="cursor:pointer">{{pd.name}}</span>-->
            <span class="caption">
            <table>
    <td>{{pd.name}}</td>
    <td style="color:#3e8ed0">{{formatBytes(pd.size, 2)}}</td>
            </table>
            </span>
                    </div>

          <div v-for="(vid,id2) in libVideos" :key="'x' + id2">
<my-video v-if="!isImageModalActive" class="__cov-video"
    :sources="[{
          src: vid.url,
          type: 'video/mp4'
        }]" :options="video.options"></my-video>
            <span class="caption">
            <table>
    <td>{{vid.name}}</td>
    <td style="color:#3e8ed0">{{formatBytes(vid.size, 2)}}</td>
            </table>
            </span>
          </div>
        </main>
     </section>

    <footer class="modal-card-foot">
      <b-button type="is-light" @click="closeModal()">Cancel</b-button>
    </footer>
  </div>
</template>

<script>
import myVideo from 'vue-video'

export default {
  name: 'PlaylistsResources',
  props: {
    playlistId: String,
    playlistName: String
  },
  components: {
    myVideo
  },
  data: () => {
    return {
      libImages: [],
      libVideos: [],
      libPdfs: [],
      loadingComponent: null,
      isImageModalActive: false,
      selectedImage: String,
      video: {
        options: {
          autoplay: false,
          volume: 0.6
        }
      }
    }
  },
  mounted: function () {
    this.loadingComponent = this.$buefy.loading.open()
    var playlistDirsRef = null
    if (!this.getNotMigrated().includes(this.$store.state.uid)) {
      playlistDirsRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/Playlists/' + this.playlistId)
    } else {
      playlistDirsRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/Playlists/' + this.playlistId)
    }
    playlistDirsRef.listAll().then((dir) => {
      dir.items.forEach(fileRef => {
        fileRef.getDownloadURL().then((url) => {
          const xhr = new XMLHttpRequest()
          xhr.responseType = 'blob'
          xhr.onload = (event) => {
            const blob = xhr.response
            var file = new File([blob], fileRef.name, {type: blob.type})
            if (blob.type.split('/')[0] === 'image') {
              this.libImages.push({ 'name': fileRef.name, 'url': url, 'file': file, 'size': blob.size })
            } else if (blob.type.split('/')[0] === 'video') {
              this.libVideos.push({ 'name': fileRef.name, 'url': url, 'file': file, 'size': blob.size })
            } else {
              this.libPdfs.push({ 'name': fileRef.name, 'url': url, 'file': file, 'size': blob.size })
            }
            this.globalLogger(this.libVideos, 'libVideos')
            this.loadingComponent.close()
          }
          xhr.open('GET', url)
          xhr.send()
        }).catch((error) => {
          this.globalLogger('error', error)
        })
      })
    })
  },
  methods: {
    formatBytes (bytes, decimals) {
      if (bytes === 0) {
        return '0 B'
      }
      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    },
    closeModal () {
      this.$parent.close()
    }
  }
}
</script>

<style scoped>
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-gap:20px;
  align-items: center;
  }
.grid img {
  box-shadow: 2px 2px 6px 0px  rgba(0,0,0,0.3);
  max-width: 100%;
}
.active {
  border: 3.2px solid #3e8ed0;
}
.caption {
    display: block;
    font-size: 10pt;
    text-align: center;
}
td, th {
  padding: 4px;
  font-size: 12px;
  max-width: 100px;
  word-break: break-all;
}
table {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/storage/playlists/PlaylistsResources.vue